import styled from 'styled-components';
import LoadingImage from '../../Global/LoadingImage/LoadingImage';
import { IonItem } from '@ionic/react';

export const BookmarksHeader = styled.h2`
	padding: 2rem 1rem;
	margin: 0;
	border-top: 1px solid var(--ion-color-medium);
`;

export const BookmarkListContainer = styled.section`
	/* padding: 1rem; */

	padding-top: 1rem;
`;

export const BookmarkContainer = styled.div`
	display: flex;
	align-items: center;
	/* padding: 1rem; */
	position: relative;
	/* transform: translate(0%, 50%); */
	overflow: visible;
	width: 100%;
	gap: 1rem;

	/* border-bottom: 1px solid var(--ion-color-medium); */
`;

export const BookmarkInner = styled(IonItem)`
	padding: 0;

	/* padding: 0.5rem; */
`;

export const BookmarkImgContainer = styled.div`
	position: relative;
	min-width: 80px;
	min-height: 80px;
	img {
		aspect-ratio: 1/1;
		width: 80px;
		height: 80px;
		object-fit: cover;
		object-position: center center;
		border-radius: 5px;
		box-shadow: var(--generic-box-shadow);
	}
`;

export const BookmarkImg = styled(LoadingImage)``;

export const BookmarkTextContainer = styled.div`
	padding: 1rem;
`;

export const BookmarkTitle = styled.h3`
	font-size: 18px;
	margin: 0;
`;

export const BookmarkMeta = styled.p`
	margin: 0;
	font-size: 0.75rem;
	//text-transform: uppercase;
	color: #257226;//var(--ion-color-secondary);
`;

export const NoBookmarksContainer = styled.div`
	width: 70%;
	margin: 0 auto;
	height: 60svh;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	ion-icon {
		font-size: 120px;
	}
	p {
		font-size: 18px;
		margin-bottom: 50px;
	}
	a {
		font-size: 14px;
		width: 80%;
		text-decoration: none;
		background: #257226;//var(--ion-color-secondary);
		color: #fff;
		padding: 10px 0;
		border-radius: 5px;
	}
`;
